<template>
    <div class="team-member-edit-properties d-flex flex-column">
        <form-checkbox
            :value="teamMember.limited_properties"
            @input="enablePropertyPermissions"
        >
            Enable Property Permissions
        </form-checkbox>
        <grid
            v-if="teamMember.limited_properties"
            ref="grid"
            :isAutoWidth="true"
            :isSearch="false"
            :columnDefs="columnDefs"
            :rowData="properties"
        ></grid>
        <associate-reservations-modal
            modal-id="associate-reservations-modal"
            :associate="true"
            :cleaner="cleaner"
            :property="property"
            @answer="getAssociateReservationsAnswer"
        ></associate-reservations-modal>
        <associate-reservations-modal
            modal-id="disassociate-reservations-modal"
            :associate="false"
            :cleaner="cleaner"
            @answer="getDisassociateReservationsAnswer"
        ></associate-reservations-modal>
    </div>
</template>

<script>
import Grid from '../../../generic/grid/grid.vue';
import FormCheckbox from '../../../generic/form-checkbox/form-checkbox.vue';
import SwitchHeaderComponent from '../../../generic/grid/switch-header-component.vue';
import AssociateReservationsModal from './associate-reservations-modal.vue';

export default {
    name: 'TeamMemberEditProperties',
    props: {
        teamMember: Object,
    },
    components: {
        Grid,
        FormCheckbox,
        AssociateReservationsModal,
        switchHeaderComponent: SwitchHeaderComponent,
    },
    data() {
        return {
            properties: [],
            allowedAll: false,
            property: '',
            cleaner: '',
            currentPropertyID: null,
            currentPropertyAllowed: null,
            headerApi: null,
        }
    },
    computed: {
        columnDefs() {
            return [
                {
                    headerName: 'Property',
                    field: 'name',
                    minWidth: 200,
                },
                {
                    field: '',
                    headerName: '',
                    minWidth: 0,
                    autoWidthExclude: true,
                    sortable: false,
                },
                {
                    headerName: 'Assign',
                    field: 'allowed',
                    type: 'switchColumn',
                    minWidth: 140,
                    maxWidth: 140,
                    headerComponent: 'switchHeaderComponent',
                    headerComponentParams: {
                        displayName: 'Assign',
                        valueGetter: () => this.allowedAll,
                        onChange: async ({ node, api }, newValue) => {
                            this.allowedAll = newValue;
                            this.headerApi = api;
                            if (this.teamMember.is_active && this.teamMember.is_cleaner) {
                                this.cleaner = `${this.teamMember.first_name} ${this.teamMember.last_name}`;
                                this.property = 'all properties';
                                if (this.allowedAll) {
                                    this.$bvModal.show('associate-reservations-modal');
                                } else {
                                    this.$bvModal.show('disassociate-reservations-modal');
                                }
                            } else {
                                this.allowPropertyAll(false, false)
                            }
                        }
                    },
                    cellRendererParams: {
                        onChange: ({ node }, value) => {
                            this.currentPropertyID = node.id;
                            this.currentPropertyAllowed = value;
                            if (this.teamMember.is_active && this.teamMember.is_cleaner) {
                                this.cleaner = `${this.teamMember.first_name} ${this.teamMember.last_name}`;
                                this.property = 'this property';
                                if (value) {
                                    this.$bvModal.show('associate-reservations-modal');
                                } else {
                                    this.$bvModal.show('disassociate-reservations-modal');
                                }
                            } else {
                                this.allowProperty(false, false)
                            }
                        }
                    }
                },
            ]
        }
    },
    methods: {
        async enablePropertyPermissions(value) {
            await this.$store.dispatch('teamMember/updateTeamMemberPropertyPermissions', {
                id: this.teamMember.id,
                limited_properties: value,
            });
        },
        async allowProperty(assignHouseKeeper, modifyReservations) {
            const allowed = this.currentPropertyAllowed;
            const data = {
                id: this.currentPropertyID,
                allowed,
                assign_house_keeper: assignHouseKeeper,
                modify_reservations: modifyReservations,
            };
            await this.$store.dispatch('teamMember/updateTeamMemberPropertiesSave', {
                id: this.teamMember.id,
                data,
            });

            this.successToast({
                text: allowed ? 'Housekeeper was assigned to the property.' : 'Assignment revoked.'
            });
        },
        async allowPropertyAll(assignHouseKeeper, modifyReservations) {
            const allowed = this.allowedAll;
            const data = {
                allowed,
                assign_house_keeper: assignHouseKeeper,
                modify_reservations: modifyReservations,
            };
            await this.$store.dispatch('teamMember/updateTeamMemberPropertiesSaveAll', {
                id: this.teamMember.id,
                data
            });

            this.successToast({text: allowed ? 'Housekeeper was assigned to all properties.' : 'Assignment revoked.'})
        },
        getAssociateReservationsAnswer(answer) {
            if (answer === 4) {
                this.properties = [...this.properties];
                this.allowedAll = this.properties.filter(property => !property.allowed).length > 0 ? false : true;
                if (this.property !== 'this property') {
                    this.headerApi.refreshHeader();
                }
            } else {
                this.property === 'this property' ? this.allowProperty(answer < 3, answer === 1) : this.allowPropertyAll(answer < 3, answer === 1)
            }
        },
        getDisassociateReservationsAnswer(answer) {
            if (answer === 4) {
                this.properties = [...this.properties];
                this.allowedAll = this.properties.filter(property => !property.allowed).length > 0 ? false : true;
                if (this.property !== 'this property') {
                    this.headerApi.refreshHeader();
                }
            } else {
                this.property === 'this property' ? this.allowProperty(false, answer === 1) : this.allowPropertyAll(false, answer === 1)
            }
        },
    },
    watch: {
        teamMember: {
            handler(teamMemberObj) {
                this.properties = [...teamMemberObj.properties];
                this.allowedAll = this.properties.filter(property => !property.allowed).length > 0 ? false : true;
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.team-member-edit-properties {
    height: 100%;
    .lx-grid {
        flex: 1;
        height: 100% !important;
    }
}
</style>
